import { axios, getAxiosConfig } from '@config/axios';
import Environment from '@config/index';
import { ChatChannelPayload } from '@interfaces/api/payloads/chatChannelPayload';
import { ChatEligibilityPayload } from '@interfaces/api/payloads/chatEligibilityPayload';
import { UserToken } from '@interfaces/models/userToken';
import { ApiResponse } from '@interfaces/api';
import { Channel } from '@interfaces/api/responses/cucha-chat-channel';
import { ZendeskWidgetToken } from '@interfaces/models/zendeskWidgetToken';

export default class ChatApiService {
  static apiBaseUrl = Environment.apiBaseUrl;

  static async createChannel(payload: ChatChannelPayload): Promise<ApiResponse<Channel>> {
    const axiosConfig = getAxiosConfig();
    const { data } = await axios.post<ApiResponse<Channel>>(`${this.apiBaseUrl}/chat/channel/`, payload, axiosConfig);
    return data;
  }

  static async getEligibility(payload: ChatEligibilityPayload): Promise<boolean> {
    const axiosConfig = getAxiosConfig();
    const {
      data: {
        data: { eligibility },
      },
    } = await axios.post(`${this.apiBaseUrl}/chat/eligibility`, payload, axiosConfig);
    return eligibility;
  }

  static async refreshToken(): Promise<UserToken> {
    const axiosConfig = getAxiosConfig();
    const {
      data: { data },
    } = await axios.get<ApiResponse<UserToken>>(`${this.apiBaseUrl}/chat/user/token`, axiosConfig);
    return data;
  }

  static async getZendeskWidgetToken(): Promise<ZendeskWidgetToken> {
    const axiosConfig = getAxiosConfig();
    const {
      data: { data },
    } = await axios.get<ApiResponse<ZendeskWidgetToken>>(
      `${this.apiBaseUrl}/partners/zendesk/messaging-session`,
      axiosConfig,
    );
    return data;
  }

  static async getChannel(channelId: string): Promise<Channel> {
    const axiosConfig = getAxiosConfig();
    const { data } = await axios.get<ApiResponse<Channel>>(`${this.apiBaseUrl}/chat/channel/${channelId}`, axiosConfig);
    return data.data;
  }
}
